import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { MAIN_FONT_FAMILY } from "../../data/constant/Constants";
import { STRINGS_CANCEl, STRINGS_OK } from "../../data/strings/Strings";
import {
  COLOR_LIGHT_GRAY,
  COLOR_WHITE,
  GRADIENT_MAIN,
} from "../../data/colors/Colors";
import { CustomTextView } from "./CustomTextView";

interface AlertDialogControls {
  open: boolean;
  title: string;
  description: string;
  mainColor?: string;
  handleNegativeButtonClick: () => void;
  handlePositiveButtonClick: () => void;
}

export const CustomAlertDialog: React.FC<AlertDialogControls> = ({
  open,
  title,
  description,
  mainColor = "rgba(220, 14, 14, 1)",
  handleNegativeButtonClick,
  handlePositiveButtonClick,
}: AlertDialogControls) => {
  return (
    <Dialog
      open={open}
      onClose={handleNegativeButtonClick}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{ style: { borderRadius: 16 } }}
    >
      <DialogTitle id="alert-dialog-title" fontFamily={MAIN_FONT_FAMILY}>
        <CustomTextView
          text={title}
          fontWeight="bold"
          variant="h6"
          textColor={mainColor}
        />
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          fontFamily={MAIN_FONT_FAMILY}
        >
          <CustomTextView text={description} />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleNegativeButtonClick}
          sx={{
            fontFamily: MAIN_FONT_FAMILY,
            borderRadius: 12,
            textTransform: "none",
          }}
        >
          <CustomTextView text={STRINGS_CANCEl} />
        </Button>
        <Button
          onClick={handlePositiveButtonClick}
          autoFocus
          sx={{
            fontFamily: MAIN_FONT_FAMILY,
            background: mainColor,
            borderRadius: 12,
            textTransform: "none",
            "&:hover": {
              background: COLOR_LIGHT_GRAY,
            },
          }}
        >
          <CustomTextView
            text={STRINGS_OK}
            fontWeight="bold"
            textColor={COLOR_WHITE}
          />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
